import { ReactNode } from 'react';
import styles from './product-list-key.module.scss';
import cx from 'classnames';

type KeyIconItemProps = {
  title: string;
  icon: ReactNode;
  isLastItem?: boolean;
};

const KeyIconItem = ({ title, icon, isLastItem = false }: KeyIconItemProps) => {
  return (
    <div
      className={cx(
        'd-flex align-items-center gap-md-3 gap-2',
        styles['product-list-key__icon-item'],
        {
          ['mb-md-3 mb-2']: !isLastItem
        }
      )}
    >
      {icon} <p className="cat-u-theme-typography-label m-0">{title}</p>
    </div>
  );
};

export default KeyIconItem;
